<template>
  <div :class="['home flex-column', programStyle]">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('security-center') }}</span>
        <ul class="subtitle flex-row">
          <li @click="goToDashboard">Dashboard&nbsp;&gt;&nbsp;</li>
          <li @click="goToDashboard">{{ domain }}&nbsp;&gt;&nbsp;</li>
          <li @click="cancelRequest">{{ $t('security-center') }}</li>
          <li v-if="addUser">&nbsp;&gt;&nbsp;{{ $t('add-user-role') }}</li>
        </ul>
      </div>
      <div class="right" v-if="appliedFilters && !pageType">
        <FilterModal
          :appliedFiltersLength="appliedFilters.length"
          :valueMulti="activeFilters"
          @clear-filters="clearAllFilters"
          @updateMulti="updateMulti"
        />
        <div>
          <Magnifier class="search-icn"></Magnifier>
          <input
            class="search-input"
            :placeholder="$t('search')"
            v-model="search"
            type="text"
            v-debounce:1000ms="searchDebounce"
          />
        </div>
      </div>
    </div>
    <div v-if="pageType === 'add'" class="content flex-column">
      <div class="add-user-container flex-column">
        <div class="pageDetails flex-row">
          <span class="action-name">Add user role</span>
          <div v-if="isValidUser && currentStep !== 'page1'" class="information-box">
            <div class="title">
              <span>Request information</span>
            </div>
            <ul class="user-details">
              <li><span>TID/SID:</span> {{ request.uid }}</li>
              <li><span>Dealer Code:</span> {{ request.entity }}</li>
              <li><span>First Name:</span> {{ request.firstName }}</li>
              <li><span>Last Name:</span> {{ request.lastName }}</li>
              <li><span>Email:</span> {{ request.email }}</li>
            </ul>
          </div>
        </div>
        <div v-if="currentStep === 'page1'" class="page1 flex-column">
          <span class="step-number">Step 1 of 3</span>
          <span class="section-label">* User information:</span>
          <ul>
            <li>* SID:</li>
            <li class="custom-input flex-row" :class="[helperTextError ? 'required' : '']">
              <input placeholder="Enter SID" v-model="request.uid" />
              <span class="custom-input-buttons flex-row">
                <span
                  class="edit-button"
                  :class="['add', multiFieldValidation(request.uid) ? '' : 'disabled']"
                  @click="getUserById"
                  >Search</span
                ><span class="separator">|</span
                ><span
                  class="edit-button"
                  :class="['add', multiFieldValidation(request.uid) ? '' : 'disabled']"
                  @click="clearRequest"
                  >{{ $t('clear') }}</span
                >
              </span>
            </li>
            <li v-if="helperTextSuccess" class="helper-text_success">
              An account has been found with this associated TID/SID!
            </li>
            <li v-if="helperTextError" class="helper-text_error">
              There are no accounts with this associated TID/SID. Please try again.
            </li>
            <li v-if="helperTextError" class="helper-text_error">
              If you wish to create a new account with this SID, please fill in the input boxes and select Save and
              Continue.
            </li>
            <li class="property-label">
              <span>Dealer code:</span>
              <span class="property-value"> {{ request.entity }}</span>
            </li>
            <li class="property-label">
              <span>Current Roles:</span>
              <span v-if="!request.uid" class="helper-text_notify">
                Not available until you’ve entered the desired SID.</span
              >
              <span id="role-name" v-for="role in request.roles" :key="role">
                {{ role }}<span class="role-comma">, </span></span
              >
            </li>
            <li>* First name:</li>
            <li class="custom-input flex-row" :class="[helperTextError ? 'required' : '']">
              <input
                :class="[helperTextError ? '' : 'disabled']"
                v-model="request.firstName"
                :placeholder="[helperTextError ? 'Enter first name' : '']"
              />
              <span v-if="helperTextError && request.firstName" class="custom-input-buttons flex-row"
                ><span
                  class="edit-button"
                  :class="['add', multiFieldValidation(request.uid) ? '' : 'disabled']"
                  @click="request.firstName = null"
                  >{{ $t('clear') }}</span
                >
              </span>
            </li>
            <li>* Last name:</li>
            <li class="custom-input flex-row" :class="[helperTextError ? 'required' : '']">
              <input
                :class="[helperTextError ? '' : 'disabled']"
                v-model="request.lastName"
                :placeholder="[helperTextError ? 'Enter last name' : '']"
              />
              <span v-if="helperTextError && request.lastName" class="custom-input-buttons flex-row"
                ><span
                  class="edit-button"
                  :class="['add', multiFieldValidation(request.uid) ? '' : 'disabled']"
                  @click="request.lastName = null"
                  >{{ $t('clear') }}</span
                >
              </span>
            </li>
            <li>Email address:</li>
            <li class="custom-input flex-row">
              <input
                :class="[helperTextError ? '' : 'disabled']"
                v-model="request.email"
                :placeholder="[helperTextError ? 'Enter email' : '']"
              />
              <span v-if="helperTextError && request.email" class="custom-input-buttons flex-row"
                ><span
                  class="edit-button"
                  :class="['add', multiFieldValidation(request.uid) ? '' : 'disabled']"
                  @click="request.email = null"
                  >{{ $t('clear') }}</span
                >
              </span>
            </li>
          </ul>
        </div>
        <div class="page2" v-else-if="currentStep === 'page2'">
          <span class="step-number">Step 2 of 3</span>
          <span class="section-label">* request action:</span>
          <Multiselect
            v-model="request.action"
            :options="roleActions"
            class="multiselect single"
            :placeholder="'Select an action'"
            :showLabels="false"
            :allow-empty="false"
          ></Multiselect>
          <span class="helper-text_notify"
            >You cannot revoke or change a role if there are no current role(s) available.</span
          >
        </div>
        <div class="page3" v-else-if="currentStep === 'page3'">
          <span class="step-number">Step 3 of 3</span>
          <div
            class="action-change-role"
            v-if="request.action && request.action === 'Change' && roleOptions.length > 0"
          >
            <span class="section-label">* Change Role</span>
            <div class="flex-row">
              <Multiselect
                v-model="request.oldRole"
                :options="request.roles"
                class="multiselect single"
                :placeholder="'Select a role'"
                :showLabels="false"
                :allow-empty="false"
              ></Multiselect>
              <p>To</p>
              <Multiselect
                v-model="request.newRole"
                :options="roleOptions"
                class="multiselect single"
                :placeholder="'Select a role'"
                :showLabels="false"
                :allow-empty="false"
              ></Multiselect>
            </div>
          </div>
          <div class="flex-row">
            <div v-if="request.action && request.action === 'Add' && roleOptions.length > 0" class="dropdown-group">
              <span class="section-label">* add role:</span>
              <Multiselect
                v-model="request.newRole"
                :options="roleOptions"
                class="multiselect single"
                :placeholder="'Select Role'"
                :showLabels="false"
                :allow-empty="false"
              ></Multiselect>
            </div>
            <div v-if="request.action && request.action === 'Revoke'" class="dropdown-group">
              <span class="section-label">* revoke role:</span>
              <Multiselect
                v-model="request.oldRole"
                :options="request.roles"
                class="multiselect single"
                :placeholder="'Select Role'"
                :showLabels="false"
                :allow-empty="false"
              ></Multiselect>
            </div>
            <div class="dropdown-group">
              <span class="section-label">* add domain(s):</span>
              <Multiselect
                v-model="selectedDomains"
                :options="domainOptions"
                class="multiselect single"
                :placeholder="'Select domain(s)'"
                :showLabels="false"
                :allow-empty="true"
                track-by="name"
                label="name"
                :multiple="true"
                :close-on-select="false"
                @select="onSelect($event)"
                @remove="onRemove($event)"
              >
                <template v-if="values.length > 3" slot="selection" slot-scope="{ values, search, isOpen }"
                  ><span class="multiselect__single" v-if="values.length" v-show="!isOpen"
                    >{{ values.length }} options selected</span
                  ></template
                >
                <span class="checkbox-label" slot="option" slot-scope="scope">
                  <input type="checkbox" v-model="scope.option.checked" @focus.prevent :key="scope.option.label" />
                  <span>{{ scope.option.name }}</span>
                </span>
              </Multiselect>
            </div>
          </div>
          <GInput
            type="textarea"
            v-model="request.requestReason"
            maxlength="500"
            :showCount="true"
            class="input-box"
            :placeholder="'Enter detailed reason'"
          ></GInput>
        </div>
        <div class="button-container flex-row">
          <div class="nav-buttons">
            <button
              v-if="currentStep === 'page1' && this.helperTextError"
              :class="['add', pageOneNewUserValidation ? '' : 'disabled']"
              :disabled="!pageOneNewUserValidation"
              @click="getUserById() + nextPage()"
            >
              Save and Continue
            </button>
            <button v-if="currentStep === 'page2' || currentStep === 'page3'" class="back-button" @click="previousPage">
              Back
            </button>
            <button
              v-if="currentStep === 'page1' && !this.helperTextError"
              :class="['add', pageOneValidation ? '' : 'disabled']"
              :disabled="!pageOneValidation"
              @click="nextPage"
            >
              Next
            </button>
            <button
              v-if="currentStep === 'page2'"
              :class="['add', pageTwoValidation ? '' : 'disabled']"
              :disabled="!pageTwoValidation"
              @click="nextPage"
            >
              Next
            </button>
            <button
              v-if="currentStep === 'page3'"
              :class="['add', pageThreeValidation ? '' : 'disabled']"
              :disabled="!pageThreeValidation"
              @click="addNewUser"
            >
              Submit
            </button>
          </div>
          <button class="cancel-button" @click="isModalOpen = true">Cancel Request</button>
        </div>
      </div>
    </div>
    <div v-if="!pageType" class="content flex-column">
      <div class="above-table flex-column">
        <div class="table-descriptors flex-row">
          <span>{{ $t('dealer-users') }}</span>
          <button @click="pageType = 'add'">Submit User Role</button>
        </div>
      </div>
      <div class="table-container flex-column">
        <DataTable :headings="dealerSecurityCenterTH" :rows="requests" :perPage="numPerPage" :page="currentPage">
          <template v-slot:viewSlot="slotProps">
            <Eyecon class="eyecon" @click="getSingleRequest(slotProps.row.id)"></Eyecon>
          </template>
        </DataTable>
        <div v-if="requests.length === 0" class="empty-table-message">
          <span v-if="this.appliedFilters.length > 0"
            >Sorry, we couldn't find anything that matches that criteria. Try broadening your search by selecting fewer
            filters.</span
          >
          <span v-else-if="search.length > 0">Sorry, we couldn't find anything that matches that criteria.</span>
          <span v-else
            >There are no dealers assigned to this dealership as an Owner or Owner Surrogate yet. To assign dealers and
            update their roles, start by
            <span class="attention" @click="pageType = 'add'">adding a user role.</span></span
          >
        </div>
        <div class="row-container">
          <div class="row-info">
            {{ $t('viewing-firstrow-lastrow-of-forms-totalcount', [firstRow, lastRow, totalCount]) }}
          </div>
          <GPagination
            v-if="pageCount > 1"
            class="pagination"
            v-model="page"
            :pageCount="pageCount"
            @changed="getRequestsWithLoad"
          />
        </div>
      </div>
    </div>
    <div v-if="pageType === 'view'" class="content flex-column">
      <div class="view-request-container">
        <div class="request-details flex-column">
          <span class="action-name">View Request</span>
          <div>
            <span class="section-label">Request Details:</span>
            <ul>
              <li><span>Role Type:</span> {{ selectedRequest.roleType }}</li>

              <li v-if="selectedRequest.roleType === 'Dealer'">
                <span>Dealer Code:</span> {{ selectedRequest.entity }}
              </li>
              <li><span>TID/SID:</span> {{ selectedRequest.userId }}</li>
              <li><span>Name:</span> {{ selectedRequest.firstName }} {{ selectedRequest.lastName }}</li>
              <li><span>Email:</span> {{ selectedRequest.email }}</li>
              <li v-if="selectedRequest.action === 'Add'"><span>Role:</span> {{ selectedRequest.newRole }}</li>
              <li v-else><span>Role:</span> {{ selectedRequest.oldRole }}</li>
              <li><span>Action:</span> {{ selectedRequest.action }}</li>
              <li v-if="selectedRequest.action === 'Change'"><span>New Role:</span> {{ selectedRequest.newRole }}</li>
              <li><span>Request Reason:</span> {{ selectedRequest.requestReason }}</li>
            </ul>
            <span class="section-label">Requested By:</span>
            <ul>
              <li><span>TID/SID:</span> {{ selectedRequest.requestedBy }}</li>
              <li><span>Name:</span> {{ selectedRequest.addedByFirstName }} {{ selectedRequest.addedByLastName }}</li>
              <li><span>Date of Creation:</span> {{ selectedRequest.requestDate | date }}</li>
            </ul>
            <div class="request-actions" v-for="request in selectedRequestArray" :key="request.requestNumber">
              <span class="action-name">Request #{{ request.requestNumber }}:</span>
              <ul>
                <li><span>Domain:</span> {{ request.domainName }}</li>
                <li><span>Status:</span> {{ request.status }}</li>
                <li><span>Review Reason:</span> {{ request.reviewReason }}</li>
              </ul>
            </div>
          </div>
          <div class="button-container flex-row">
            <button @click="exit">Back</button>
          </div>
        </div>
      </div>
    </div>
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="body">
        <div class="modal-content">
          <span class="modal-title">Confirm Cancellation?</span>
          <span class="modal-text"
            >You are cancelling this request. This action cannot be undone. Are you sure you want to confirm your
            cancellation?</span
          >
        </div>
        <div class="modal-button-container">
          <button class="submit" @click="cancelRequest">Confirm</button>
          <button class="cancel-button" @click="isModalOpen = false">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import Eyecon from '@/assets/new/eye-con.svg';
import Modal from '@/components/Modal.vue';
import GPagination from '@/components/GComponents/GPagination.vue';
import { mapState } from 'vuex';
import dealerSecurityCenterTH from '@/utils/tableHeaders/dealerSecurityCenterTH';
import GInput from '@/components/GComponents/GInput.vue';
import Multiselect from 'vue-multiselect';
import Magnifier from '@/assets/icons/magnifier.svg';
import FilterModal from '@/components/FilterModal.vue';

const requestRoleFilterOptions = [
  {
    label: 'Dealer Owner',
    checked: false,
  },
  {
    label: 'Dealer Owner Surrogate',
    checked: false,
  },
];

const requestStatusFilterOptions = [
  {
    label: 'Active',
    checked: false,
  },
  {
    label: 'Cancelled',
    checked: false,
  },
  {
    label: 'Partial',
    checked: false,
  },
  {
    label: 'Approved',
    checked: false,
  },
  {
    label: 'Denied',
    checked: false,
  },
];

export default {
  name: 'Dealer-Security-Center',
  components: {
    DataTable,
    Eyecon,
    Modal,
    GPagination,
    GInput,
    Multiselect,
    Magnifier,
    FilterModal,
  },
  data() {
    return {
      requests: [],
      dealerSecurityCenterTH: dealerSecurityCenterTH(),
      search: '',
      page: 1,
      numPerPage: 10,
      currentPage: 1,
      totalCount: null,
      rowCountDropValue: { label: this.$t('show-10'), value: 10 },
      tempRow: null,
      isModalOpen: false,
      addUser: false,
      pageType: null,
      request: {
        domain: null,
        domains: [],
        entity: this.$attrs.selectedDealer.entity,
        uid: null,
        roleType: null,
        oldRole: null,
        newRole: null,
        action: null,
        reason: null,
        firstName: null,
        lastName: null,
        email: null,
        status: null,
        requestReason: null,
      },
      roleOptions: [],
      domainOptions: [],
      selectedDomains: null,
      currentEdit: null,
      roleFilter: [],
      statusFilter: [],
      appliedFilters: null,
      multiFilterOptions: {},
      requestRoleFilterOptions,
      requestStatusFilterOptions,
      steps: ['page1', 'page2', 'page3'],
      currentStep: 'page1',
      currentStepIndex: 0,
      isValidUser: false,
      helperTextSuccess: false,
      helperTextError: false,
      selectedRequestArray: [],
      selectedRequest: null,
      roleActions: [],
    };
  },
  methods: {
    nextPage() {
      this.currentStepIndex += 1;
      this.currentStep = this.steps[this.currentStepIndex];
    },
    previousPage() {
      this.currentStepIndex -= 1;
      this.currentStep = this.steps[this.currentStepIndex];
    },
    searchDebounce() {
      const loader = this.$loading.show();
      this.page = 1;
      this.getRoleRequests();
      loader.hide();
    },
    getRoleRequests() {
      const loader = this.$loading.show();

      const { domain, roleFilter, statusFilter, search } = this;
      const page = this.page - 1;
      this.$store
        .dispatch('getRoleRequests', {
          domain,
          roleFilter,
          statusFilter,
          search,
          page,
        })
        .then((res) => {
          this.requests = res.allDealerRequests;
          this.totalCount = res.totalCount;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getRequestsWithLoad() {
      this.getRoleRequests();
    },
    getSingleRequest(id) {
      const loader = this.$loading.show();

      this.isModalOpen = false;

      this.$store
        .dispatch('getSingleRequest', {
          id,
        })
        .then((res) => {
          this.setSingleRequest(res.data.singleRequest);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setSingleRequest(request) {
      let counter = 0;

      request.forEach((subRequest) => {
        const tempObject = {
          domainName: subRequest.fullDomainName,
          requestedBy: subRequest.addedBy,
          requestDate: subRequest.createdAt,
          bcName: subRequest.fullBCName,
          requestNumber: (counter += 1),
        };
        Object.assign(subRequest, tempObject);
      });

      this.selectedRequestArray.push(...request);
      this.selectedRequest = this.selectedRequestArray[0];
      this.pageType = 'view';
    },
    exit() {
      const loader = this.$loading.show();
      this.selectedRequestArray = [];
      this.selectedRequest = null;
      this.pageType = null;
      loader.hide();
    },
    getUserById() {
      const loader = this.$loading.show();

      const { domain } = this;

      const { uid, firstName, lastName, email, entity } = this.request;

      this.$store
        .dispatch('getUserByIdDealer', {
          domain,
          uid,
          firstName,
          lastName,
          email,
          entity,
          roleType: 'Dealer',
        })
        .then((res) => {
          this.isValidUser = true;
          this.helperTextSuccess = true;
          this.setUserRoles(res.user);
          this.setRoleActions();
          this.getRoleOptions();
          this.getMultipleDomains();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
            this.helperTextError = true;
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setRoleActions() {
      if (this.request.roles.length > 0 && this.roleOptions.length === 0) {
        // Add Change and Revoke options if user has existing role(s)
        this.roleActions.push('Revoke');
        const tempSet = [...new Set(this.roleActions)];
        this.roleActions = Array.from(tempSet);
      }
    },
    getMultipleDomains() {
      const loader = this.$loading.show();

      this.$store
        .dispatch('getMultipleDomains', { roleType: 'Dealer' })
        .then((res) => {
          this.setDomainOptions(res);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setDomainOptions(domains) {
      domains.forEach((domain) => {
        const tempObj = { checked: false, name: domain.fullDomainName, abbreviation: domain.domain };
        this.domainOptions.push(tempObj);
      });
    },
    onSelect(option) {
      // WIP
      // if (option.label === 'Select all') {
      //   this.bcOptions.forEach((item) => {
      //     item.checked = true;
      //   });
      // }
      const index = this.domainOptions.findIndex((item) => item.abbreviation === option.abbreviation);
      this.domainOptions[index].checked = true;
      this.request.domains.push(option.abbreviation);
    },
    onRemove(option) {
      const index = this.domainOptions.findIndex((item) => item.abbreviation === option.abbreviation);
      this.domainOptions[index].checked = false;
      this.request.domains.splice(index, 1);
    },
    cancelRequest() {
      const loader = this.$loading.show();
      this.isModalOpen = false;
      this.$notify({
        group: 'primary',
        type: 'success',
        text: this.$t('request-successfully-cancelled'),
      });
      this.clearRequest();
      this.pageType = null;
      this.currentStep = 'page1';
      this.currentStepIndex = 0;
      this.getRoleRequests();
      loader.hide();
    },
    clearRequest() {
      this.request = {
        entity: this.$attrs.selectedDealer.entity,
        uid: null,
        roleType: null,
        oldRole: null,
        newRole: null,
        action: null,
        reason: null,
        firstName: null,
        lastName: null,
        email: null,
        status: null,
        domains: [],
      };
      this.roleOptions = [];
      this.domainOptions = [];
      this.selectedDomains = null;
      this.isValidUser = false;
      this.helperTextSuccess = false;
      this.helperTextError = false;
    },
    setUserRoles(details) {
      const rolesArr = [];
      details.roles.forEach((roleDetail) => {
        rolesArr.push(roleDetail.role);
      });
      Object.assign(this.request, details);
      this.request.roles = rolesArr;
      this.request.domains = [];
    },
    getRoleOptions() {
      const loader = this.$loading.show();

      const { domain } = this;
      const { uid: userId, entity } = this.request;

      this.$store
        .dispatch('getRoleOptions', {
          domain,
          userId,
          entity,
        })
        .then((res) => {
          this.roleOptions = res.filteredDealerList;
          // Include Add option for dropdown if user has available role(s)
          if (this.request.roles.length === 0 && this.roleOptions.length > 0) {
            this.roleActions.push('Add');
            const tempSet = [...new Set(this.roleActions)];
            this.roleActions = Array.from(tempSet);
          }
          if (this.request.roles.length > 0 && this.roleOptions.length > 0) {
            this.roleActions.push('Change');
            const tempSet = [...new Set(this.roleActions)];
            this.roleActions = Array.from(tempSet);
          }
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    addNewUser() {
      const loader = this.$loading.show();

      const { uid: userId, action, newRole, oldRole, requestReason, domains } = this.request;

      const params = {
        domains,
        action,
        userId,
        oldRole,
        newRole,
        requestReason,
      };

      this.$store
        .dispatch('addNewUser', params)
        .then((res) => {
          if (res) {
            this.getRoleRequests();
            this.addUser = false;
            this.$notify({
              group: 'primary',
              type: 'success',
              text: 'User role successfully added!',
            });
            this.pageType = null;
            this.currentStep = 'page1';
            this.currentStepIndex = 0;
            this.helperTextSuccess = false;
            this.domainOptions = [];
            this.selectedDomains = null;
            this.roleActions = [];
          }
        })
        .catch((error) => {
          this.$notify({
            group: 'primary',
            type: 'error',
            text: error.data.error,
          });
        })
        .finally(() => {
          loader.hide();
        });
    },
    openModal(data) {
      this.tempRow = data;
      this.isModalOpen = true;
    },
    goToDashboard() {
      this.$router.push({
        name: 'Dashboard',
      });
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
    getFilters() {
      const RoleFilters = this.requestRoleFilterOptions;
      const StatusFilters = this.requestStatusFilterOptions;

      this.multiFilterOptions = {
        Role: RoleFilters,
        Status: StatusFilters,
      };
      this.createFilters();
    },
    createFilters() {
      this.roleFilter = [];
      this.statusFilter = [];

      this.$store.state.activeSecurityCenterFilters = this.multiFilterOptions;
      this.setAppliedFilters();
    },
    setAppliedFilters() {
      this.roleFilter = [];
      this.statusFilter = [];

      const { roleFilter, statusFilter } = this;

      let length = 0;
      if (this.activeFilters) {
        if (this.activeFilters.Role) {
          this.activeFilters.Role.forEach((option) => {
            if (option.checked) roleFilter.push(option.label);
          });
        }
        if (this.activeFilters.Status) {
          this.activeFilters.Status.forEach((option) => {
            if (option.checked) statusFilter.push(option.label);
          });
        }
      }
      length = statusFilter.length + roleFilter.length;
      this.appliedFilters = {
        statusFilter,
        roleFilter,
        length,
      };
    },
    updateMulti(updates) {
      const loader = this.$loading.show();
      this.page = 1;
      this.multiFilterOptions = updates;
      this.$store.state.activeSecurityCenterFilters = this.multiFilterOptions;
      this.setAppliedFilters();
      this.getRoleRequests();
      loader.hide();
    },
    clearAllFilters() {
      if (this.multiFilterOptions.Status) {
        this.multiFilterOptions.Status.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Role) {
        this.multiFilterOptions.Role.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      this.appliedFilters.length = 0;
      this.$store.state.activeSecurityCenterFilters = this.multiFilterOptions;
    },
    multiFieldValidation(value) {
      if (value) {
        return true;
      }
      return false;
    },
  },
  computed: {
    ...mapState('global', ['programName', 'programStyle']),
    ...mapState(['activeNavBar', 'activeNavTab']),
    ...mapState({
      domain: (state) => state.global.programName,
      activeFilters: 'activeSecurityCenterFilters',
    }),
    pageOneValidation() {
      if (
        this.request.uid &&
        this.request.entity &&
        this.request.firstName &&
        this.request.lastName &&
        this.request.email
      ) {
        return true;
      }
      return false;
    },
    pageTwoValidation() {
      if (this.request.action) {
        return true;
      }
      return false;
    },
    pageOneNewUserValidation() {
      if (this.request.uid && this.request.firstName && this.request.lastName) {
        return true;
      }
      return false;
    },
    pageThreeValidation() {
      if (this.request.uid && this.request.requestReason && this.request.action && this.request.domains.length > 0) {
        if (this.request.action === 'Change' || this.request.action === 'Revoke') {
          if (this.request.oldRole) {
            return true;
          }
          return false;
        }
        if (this.request.action === 'Add') {
          if (this.request.newRole) {
            return true;
          }
          return false;
        }
      }
      return false;
    },
    pageCount() {
      if (this.requests) {
        const l = this.totalCount;
        const s = this.rowCountDropValue.value;
        return Math.ceil(l / s);
      }
      return null;
    },
    firstRow() {
      if (this.requests.length > 0) {
        return (this.page - 1) * 10 + 1;
      }
      return 0;
    },
    lastRow() {
      return (this.page - 1) * 10 + this.requests.length;
    },
  },
  watch: {
    'request.uid': function () {
      if (this.helperTextSuccess || this.helperTextError) {
        this.clearRequest();
      }
    },
  },
  created() {
    this.getRoleRequests();
    this.getFilters();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    list-style-type: none;
    margin-bottom: 0px;
    padding-left: 0px;
    li {
      cursor: pointer;
    }
    li:last-child {
      cursor: default;
      font-weight: bold;
    }
  }
  button:hover {
    text-decoration: underline;
  }
}
.content {
  height: 100%;
  flex-wrap: wrap;
  margin-top: 30px;
  p {
    font-size: 18px;
    color: $primary-black;
    margin: 0px;
  }
  .sub-title {
    text-align: left;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .flexRow {
    display: flex;
    margin-top: 20px;
    input {
      margin-left: 20px;
    }
  }
  .flex-column {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  .small-title {
    color: black;
    font-size: 20px;
    margin-right: 20px;
  }
  .setup-row-1 {
    margin: 15px 0px 20px 0px;
  }
  .multiselect {
    margin-right: 15px;
  }
  button {
    margin-right: 20px;
  }
  .button-container {
    margin-top: 25px;
    button {
      margin-right: 20px;
    }
  }
  ul {
    padding: 0;
    list-style-type: none;
    li {
      margin-left: 0;
      color: $primary-black;
    }
    span {
      font-size: inherit;
      font-family: 'Encode Sans', sans-serif;
      font-weight: medium;
    }
    button {
      margin: 0px 20px;
    }
  }
}
.above-table {
  padding: 0px 57px 0px 49px;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 35px 30px 30px;
  justify-content: space-between;
  .right {
    margin-top: 2px;
    display: flex;
    .search-input {
      width: 243px;
    }
  }
  .subtitle {
    li {
      color: #243882;
    }
  }
}
.table-descriptors {
  justify-content: space-between;
  font-size: 24px;
  align-items: flex-end;
  button {
    margin-right: 0px;
  }
  .right {
    display: flex;
    input {
      margin-right: 20px;
    }
  }
}
.table-container {
  margin-top: 24px;
  .empty-table-message {
    display: flex;
    justify-content: center;
    margin: 40px 400px;
    span {
      font-size: 24px;
    }
    .attention {
      text-decoration: underline;
      cursor: pointer;
      margin-left: 3px;
      font-weight: bold;
    }
  }
}
.cancel-button,
.back-button {
  background-color: $primary-white;
  border: 1px solid $primary;
  color: $primary;
}
.cancel-button {
  margin-right: 0px !important;
}
.add-user-container {
  margin: 0px 30px 0px;
  .step-number {
    font-size: 14px;
    color: #282b34;
    margin: 10px 0px 30px;
    display: block;
    opacity: 0.5;
  }
  .property-label {
    font-size: 14px;
    font-weight: bold;
  }
  .section-label {
    color: $primary-black;
    font-size: 15px;
    text-transform: uppercase;
    margin-bottom: 20px;
    display: block;
    font-weight: bold;
  }
  .action-name {
    font-size: 18px !important;
    text-transform: uppercase;
    font-weight: bold;
  }
  .information-box {
    position: absolute;
    right: 30px;
    border: 1px solid #707070;
    width: 297px;
    color: $primary-black;
    span {
      font-size: 14px;
    }
    .title {
      height: 57px;
      background-color: #243782;
      color: $primary-white;
      padding-left: 30px;
      font-weight: bold;
    }
    ul {
      padding: 20px 30px 25px;
      margin: 0px;
      li {
        font-size: 14px;
        margin-bottom: 5px;
      }
      li:last-child {
        margin: 0px;
      }
      span {
        font-weight: bold;
      }
    }
  }
  text-align: left;
  span {
    font-size: 21px;
  }
  input {
    outline: 0;
    &:read-only {
      color: #282b3480;
    }
  }
  .input-box {
    width: 704px;
    margin-bottom: 0px;
  }
  .helper-text {
    font-size: 14px;
    color: $primary-black;
    &_success {
      color: #008716 !important;
    }
    &_error {
      color: red !important;
      font-size: 14px !important;
    }
    &_notify {
      color: $primary-black;
      opacity: 0.5 !important;
      font-size: 14px !important;
      font-weight: lighter;
    }
  }
  .page1 {
    .disabled {
      opacity: 0.7;
      cursor: default;
      pointer-events: none;
    }
    .edit-input {
      margin-left: 28px;
    }
    ul {
      margin: 0px;
      li:nth-child(odd) {
        margin-bottom: 10px;
      }
      li:nth-child(even) {
        margin-bottom: 15px;
      }
      li {
        font-size: 15px;
        color: #282b34;
        input {
          height: 43px;
          width: 286px;
        }
        input.disabled {
          pointer-events: none;
          background: #d1d1d1;
          opacity: 0.58;
        }
      }
      li:last-child {
        margin-bottom: 0px;
      }
      .custom-input {
        border: 1px solid #a3a3a3;
        width: 289px;
        height: 47px;
        justify-content: space-between;
        input {
          border: none;
          padding: 0px 15px;
          height: 100%;
        }
        .custom-input-buttons {
          padding: 0px 15px;
          align-items: center;
          .separator {
            color: #d1d1d1;
            margin: 0px 7.5px;
          }
          .edit-button {
            font-size: 14px;
            color: #243882;
            cursor: pointer;
          }
        }
      }
      .required {
        border: 1px solid red !important;
      }
      .custom-input {
        width: 310px !important;
        input {
          height: 47px;
          width: 100%;
        }
      }
    }
    .submit-user-details {
      input {
        margin: 0px;
      }
      .separator {
        font-weight: lighter;
        color: $fca-gray;
        margin: 0px 5px;
      }
      .edit-button {
        color: #243882;
        text-transform: uppercase;
        cursor: pointer;
      }
    }
  }
  .property-value {
    font-family: 'Encode Sans', sans-serif;
    font-weight: lighter;
  }
  #role-name {
    font-family: 'Encode Sans', sans-serif;
    font-weight: lighter !important;
  }
  .role-comma {
    font-weight: inherit !important;
  }
  #role-name:last-of-type {
    .role-comma {
      visibility: hidden;
    }
  }
  .dropdown-group {
    margin-right: 15px;
  }
  .multiselect {
    margin: 20px 0px 15px;
    width: 289px !important;
    .checkbox-label {
      display: block;
      margin: 0;
      padding: 0;
      input {
        height: 17px;
        width: 17px;
      }
      span {
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .multiselect__single {
      font-size: 18px;
    }
  }
  .action-change-role {
    .flex-row {
      align-items: center;
    }
    p {
      margin: 0px 10px;
    }
  }
  .button-container {
    margin-top: 45px;
    justify-content: space-between;
  }
}
.view-request-container {
  margin: 0px 30px 45px;
  span {
    font-size: 21px;
  }
  text-align: left;
  .section-label {
    font-size: 14px;
    margin: 25px 0px 20px;
    color: $primary-black;
    text-transform: uppercase;
    display: block;
    font-weight: bold;
  }
  .user-details {
    margin-top: 20px;
    input {
      width: 275px;
      margin-bottom: 20px;
    }
  }
  .request-details {
    ul {
      border: 1px solid #d1d1d1;
      margin: 0px;
      padding: 20px;
      width: 704px;
      li {
        font-size: 14px;
        color: $primary-black;
        margin-bottom: 15px;
        span {
          font-weight: bold;
          font-size: 14px;
        }
      }
      li:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .request-actions {
    border-top: 1px solid #d1d1d1;
    margin-top: 30px;
    padding-top: 30px;
    ul {
      margin-top: 25px !important;
    }
  }
}
.modal-button-container {
  display: flex;
  margin-top: 34px;
  justify-content: center;
  .submit {
    margin-right: 20px;
  }
}
.modal-body {
  display: flex;
  flex-direction: column;
  .close {
    display: flex;
    justify-content: flex-end;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
  .modal-content {
    width: 100%;
    text-align: center;
  }
  .modal-title {
    font-size: 20px;
    text-transform: uppercase;
    font-weight: bold;
    display: block;
    margin-bottom: 20px;
  }
  .modal-text {
    font-size: 14px;
    color: $primary-black;
    display: block;
  }
}
</style>
